<div class="min-h-screen bg-white font-inter text-slate-950">
  <div class="flex min-h-screen flex-col items-center justify-center gap-8 px-6 py-12">
    <img
      src="assets/brand/logo.svg"
      width="48"
      height="48"
      alt="FormOps logo"
      class="h-12 w-12 rounded-2xl bg-white p-1.5 shadow-lg shadow-black/10" />

    @if (pageStatus() === 'loading') {
      <div class="flex flex-col items-center gap-3 text-center">
        <h1 class="text-h5 font-semibold text-slate-950">Loading invitation…</h1>
        <p class="max-w-md text-body1 text-slate-600">
          Please wait while we verify your invite link.
        </p>
      </div>
    } @else if (pageStatus() === 'error') {
      <div class="flex flex-col items-center gap-8 text-center">
        <div class="flex flex-col items-center gap-3">
          <h1 class="text-h5 font-semibold text-slate-950">Invitation unavailable</h1>
          <p class="max-w-md text-body1 text-slate-600">
            {{ errorMessage() }}
          </p>
        </div>
        <a routerLink="/login" class="text-body2 font-medium text-primary-600 hover:text-primary-700">
          Go to sign in
        </a>
      </div>
    } @else {
      <div class="flex flex-col items-center gap-8 text-center">
        <div class="flex flex-col items-center gap-3">
          <h1 class="text-h5 font-semibold text-slate-950">Join {{ preview()?.workspaceName }}</h1>
          <p class="max-w-md text-body1 text-slate-600">
            You have been invited as
            <span class="font-medium text-slate-900">{{ preview()?.role }}</span>
            for
            <span class="font-medium text-slate-900">{{ preview()?.invitedEmail }}</span>.
          </p>
        </div>

        @if (pageStatus() === 'email-mismatch') {
          <p class="max-w-md text-body2 text-amber-700">
            Sign in as {{ preview()?.invitedEmail }} to accept this invitation.
          </p>
        }

        @if (tokenStorage.isAuthenticated()) {
          <lib-signal-button
            [loading]="acceptState.loading()"
            [disabled]="acceptState.loading() || pageStatus() === 'email-mismatch'"
            (clicked)="onAcceptClicked()">
            Accept invitation
          </lib-signal-button>
        } @else {
          <div class="flex w-full max-w-sm flex-col gap-3">
            <button
              type="button"
              class="cursor-pointer inline-flex items-center justify-center gap-3 rounded-xl border border-slate-300 bg-white px-5 py-2 text-body2 font-medium text-slate-900 transition"
              (click)="onGoogleSignInClicked()">
              <app-svg-icon src="assets/icons/social/google.svg" [size]="24" />
              Continue with Google
            </button>

            <lib-signal-button appearance="outline" (clicked)="onSignInClicked()">
              Sign in with email
            </lib-signal-button>

            <lib-signal-button appearance="ghost" (click)="onCreateAccountClicked()">
              Create an account
            </lib-signal-button>

          </div>
        }
      </div>
    }
  </div>
</div>
